import { z } from 'zod';
import { LEAD_INTENTS } from '@/lib/leads/leadIntents';

export const SaveLeadInputSchema = z.object({
  name: z.string().describe("The full name of the person making the inquiry."),
  email: z.string().email().optional().or(z.literal("")),
  message: z.string().describe("The message or inquiry from the person."),
  profileOwnerId: z.string().describe("The unique ID of the profile owner who is receiving this lead."),
  bookingId: z.string().optional().describe("Optional linked booking ID when this lead came from a booking flow."),
  bookingProfileId: z.string().optional().describe("The profile whose diary holds the linked booking (differs from profileOwnerId for room bookings)."),
  whatsappNumber: z.string().optional().describe("The optional WhatsApp number of the person making the inquiry."),
  intent: z.enum(LEAD_INTENTS).optional().describe("Classifies the lead intent for analytics and routing."),
});
export type SaveLeadInput = z.infer<typeof SaveLeadInputSchema>;

export const SaveLeadOutputSchema = z.object({
  leadId: z.string(),
  summary: z.string(),
});
export type SaveLeadOutput = z.infer<typeof SaveLeadOutputSchema>;
